var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 98,
    viewBox: "0 0 91 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5782 19.4669H63.2676C65.052 19.4669 66.512 18.0069 66.512 16.2224V9.73347C66.512 4.38006 62.132 0 56.7786 0H34.0671C28.7137 0 24.3337 4.38006 24.3337 9.73347V16.2224C24.3337 18.0069 25.7937 19.4669 27.5782 19.4669Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1122 8.11133H77.8678C76.8944 8.11133 76.2455 8.76023 76.2455 9.73357V16.2226C76.2455 23.3604 70.4054 29.2005 63.2675 29.2005H27.5782C20.4403 29.2005 14.6002 23.3604 14.6002 16.2226V9.73357C14.6002 8.76023 13.9513 8.11133 12.978 8.11133H9.73347C4.38006 8.11133 0 12.4914 0 17.8448V87.6013C0 92.9547 4.38006 97.3348 9.73347 97.3348H81.1122C86.4657 97.3348 90.8457 92.9547 90.8457 87.6013V17.8448C90.8457 12.4914 86.4657 8.11133 81.1122 8.11133ZM72.6766 47.0452L41.5295 78.1923C40.7183 79.0034 39.745 79.4901 38.6094 79.4901C37.4739 79.4901 36.3383 79.0034 35.5272 78.1923L18.1691 60.8343C17.358 60.0232 17.358 59.0498 18.1691 58.2387L21.5759 54.832C22.387 54.0209 23.3603 54.0209 24.1714 54.832L38.4472 69.1077L66.512 41.0429C67.3232 40.2318 68.2965 40.2318 69.1076 41.0429L72.5143 44.4496C73.3255 45.2607 73.3255 46.3963 72.6766 47.0452Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.559fb69e0b818d72dcf2cfcfc9e27e6d.svg";
export { ForwardRef as ReactComponent };